import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { IFormState } from '@vimcar/shared-components/components/IForm'
import type {
  Props as TextFieldProps,
  ViewModel as TextFieldViewModel,
} from '@vimcar/shared-components/components/IForm/components/TextField/viewModel'
import type React from 'react'

import * as mobx from 'mobx'

import i18n from '../../../utils/i18n'

const tp = i18n.prefixWithoutTestId('IForm.components.TextArea')

export type ViewModel = {
  placeholder: string
  handleFocus: () => void
  handleBlur: React.FocusEventHandler
  handleChange: React.ChangeEventHandler
} & TextFieldViewModel

type Props = TextFieldProps & {
  placeholder?: string
  onChange?: (
    e: React.SyntheticEvent<HTMLInputElement>,
    arg1?: IFormState<any> | null | undefined,
  ) => void
}

const mkViewModel = (params: Params, props: Props): ViewModel => {
  // @ts-expect-error@2322
  const vm: ViewModel = mobx.observable({
    placeholder: props.placeholder ? props.placeholder : '',
    handleFocus: mobx.action(() => {
      vm.placeholder = ''
    }),

    handleChange: mobx.action((e: any) => {
      if (props.onChange) props.onChange(e)
      props.field.raw = e.target.value
    }),

    handleBlur: mobx.action((e: any) => {
      if (props.onBlur) props.onBlur(e)
      props.field.showError = true
      vm.placeholder = props.placeholder ? props.placeholder : ''
    }),
  })

  props.field.setParser((value) => (value === '' ? null : value))
  props.field.addValidator(
    (value) => !props.minLength || value.length >= props.minLength,
    () => tp('invalid-min-length', { minLength: props.minLength }),
  )

  return vm
}

export default mkViewModel
